module.exports = __webpack_public_path__ + "static/media/testing_cypress.a9574ba6.png";